export default "__VITE_ASSET__DJH7iDx3__"